import { useEffect } from 'react';

const SITE_NAME = 'Ferry Gold Shipping';

const upsertMetaTag = (selector, attributes) => {
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement('meta');
    document.head.appendChild(tag);
  }

  tag.setAttribute('data-page-meta', 'true');

  Object.entries(attributes).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      tag.setAttribute(key, value);
    }
  });

  return tag;
};

const removeMetaTag = (selector) => {
  const tag = document.head.querySelector(selector);

  if (tag) {
    tag.remove();
  }
};

const upsertCanonicalTag = (href) => {
  let tag = document.head.querySelector('link[rel="canonical"]');

  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', 'canonical');
    document.head.appendChild(tag);
  }

  tag.setAttribute('data-page-meta', 'true');
  tag.setAttribute('href', href);
};

const PageMeta = ({
  title,
  description,
  keywords,
  image,
  canonicalPath,
  children,
}) => {
  useEffect(() => {
    const normalizedTitle = title?.trim();
    const pageTitle =
      normalizedTitle && normalizedTitle.toLowerCase().includes(SITE_NAME.toLowerCase())
        ? normalizedTitle
        : normalizedTitle
          ? `${normalizedTitle} | ${SITE_NAME}`
          : SITE_NAME;
    document.title = pageTitle;

    upsertMetaTag('meta[name="description"]', {
      name: 'description',
      content: description || `${SITE_NAME} provides road, air, ocean freight, warehousing, and shipment tracking services.`,
    });

    upsertMetaTag('meta[name="keywords"]', {
      name: 'keywords',
      content:
        keywords ||
        'Ferry Gold Shipping, logistics, freight forwarding, road freight, air freight, ocean freight, warehousing, shipment tracking',
    });

    upsertMetaTag('meta[property="og:title"]', {
      property: 'og:title',
      content: pageTitle,
    });

    upsertMetaTag('meta[property="og:description"]', {
      property: 'og:description',
      content: description || `${SITE_NAME} provides road, air, ocean freight, warehousing, and shipment tracking services.`,
    });

    upsertMetaTag('meta[property="og:type"]', {
      property: 'og:type',
      content: 'website',
    });

    if (image) {
      upsertMetaTag('meta[property="og:image"]', {
        property: 'og:image',
        content: image,
      });
      upsertMetaTag('meta[name="twitter:image"]', {
        name: 'twitter:image',
        content: image,
      });
    } else {
      removeMetaTag('meta[property="og:image"][data-page-meta="true"]');
      removeMetaTag('meta[name="twitter:image"][data-page-meta="true"]');
    }

    upsertMetaTag('meta[name="twitter:card"]', {
      name: 'twitter:card',
      content: image ? 'summary_large_image' : 'summary',
    });

    upsertMetaTag('meta[name="twitter:title"]', {
      name: 'twitter:title',
      content: pageTitle,
    });

    upsertMetaTag('meta[name="twitter:description"]', {
      name: 'twitter:description',
      content: description || `${SITE_NAME} provides road, air, ocean freight, warehousing, and shipment tracking services.`,
    });

    const canonicalHref = `${window.location.origin}${canonicalPath || window.location.pathname}`;
    upsertCanonicalTag(canonicalHref);
  }, [title, description, keywords, image, canonicalPath]);

  return children;
};

export default PageMeta;
